import type { CSSProperties, PointerEvent } from 'react';

interface ResizeHandleProps {
  onPointerDown: (e: PointerEvent<HTMLElement>) => void;
  /** Extra class for positioning (e.g. absolute for the inspector drawer). */
  className?: string;
  style?: CSSProperties;
  ariaLabel: string;
}

/**
 * A7 — a thin draggable divider to resize a side panel. Presentational only;
 * the drag logic lives in useResizablePanel. Keyboard users can still use the
 * panels at their default width (resize is a mouse/pointer affordance).
 */
export function ResizeHandle({ onPointerDown, className, style, ariaLabel }: ResizeHandleProps) {
  return (
    <div
      className={`panel-resize-handle ${className ?? ''}`}
      style={style}
      onPointerDown={onPointerDown}
      role="separator"
      aria-orientation="vertical"
      aria-label={ariaLabel}
      data-testid="panel-resize-handle"
    />
  );
}

// Made with Bob
